import { render, staticRenderFns } from "./tabContents.vue?vue&type=template&id=5e888ed4&"
import script from "./tabContents.vue?vue&type=script&lang=js&"
export * from "./tabContents.vue?vue&type=script&lang=js&"
import style0 from "./tabContents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabContents.vue"
export default component.exports